<template>
    <yandex-map
        v-if="shop"
        class="smart-shops-map ymap"
        :settings="mapSettings"
        :coords="coords"
        :zoom="zoom"
        :controls="[]"
        :behaviors="[]"
    >
        <ymap-marker :coords="coords" :markerId="shop.id" :icon="markerIcon" />
    </yandex-map>
</template>

<script>
import { yandexMap, ymapMarker } from 'vue-yandex-maps';

export default {
    components: {
        yandexMap,
        ymapMarker,
    },

    props: {
        shop: {
            type: Object || null,
            default: null,
        },
    },

    data() {
        return {
            mapSettings: {
                apiKey: '',
                lang: 'ru_RU',
                coordorder: 'latlong',
                enterprise: false,
                version: '2.1',
            },
            markerIcon: {
                layout: 'default#image',
                imageHref: '/assets/img/automatize/icons/contact-location.svg',
                imageSize: [30, 40],
                imageOffset: [-15, -35],
            },
            zoom: 15,
        };
    },

    computed: {
        coords() {
            if (!this.shop || !this.shop.lat || !this.shop.lon) {
                return [55.55, 37.37];
            }

            const { lat, lon } = this.shop;

            const coord = [lat, lon];

            return coord;
        },
    },
};
</script>

<style>
.smart-shops-map {
    height: 600px;
}
</style>
